export default __webpack_public_path__ + "media/graduate.0ea7e792.svg";